import { Translation } from "@/data/lang";

export const dollarFormatter = (value?: unknown): string =>
  value == null || typeof value !== "number"
    ? "-"
    : value >= 0
    ? `$${value.toLocaleString()}`
    : `-$${Math.abs(value).toLocaleString()}`;

export const instituteFormatter = ({
  t,
  value,
}: {
  t: Translation;
  value?: number;
}): string =>
  value == null
    ? "-"
    : `${value.toLocaleString()} ${t.analysis.chip.factor.institutionUnit}`;

export const percentageFormatter = (value?: unknown): string =>
  value == null ? "-" : `${value} %`;

export const formatDollarNumber = (number: number | null | undefined) => {
  if (number == null) return "-";
  const isPositive = number >= 0;
  number = Math.abs(number);
  const suffixes = ["", "K", "M", "B"];
  let suffixIndex = 0;
  while (number >= 1000 && suffixIndex < suffixes.length - 1) {
    number /= 1000;
    suffixIndex++;
  }
  return `${isPositive ? "" : "-"}$${number.toFixed(2)}${
    suffixes[suffixIndex]
  }`;
};
